












































































import { Component, Mixins } from 'vue-property-decorator'
import GlobalMixin, {ALERT_TYPE, VIEW_MODE} from '@/mixins/globalMixin'
import LoadingComponent from '@/components/LoadingComponent.vue'
import AlertBarComponent from '@/components/AlertBarComponent.vue'
import BreadcrumbsComponent from '@/components/BreadcrumbsComponent.vue'
import CustomerDialogComponent from '@/components/CustomerDialogComponent.vue'
import { Customer } from '@/domain/Customer'
import { CustomerInfo } from '@/domain/CustomerInfo'
import { Prefectur } from '@/domain/Prefectur'
import CustomersService from '@/service/CustomersService'
import PrefecturesService from '@/service/PrefecturesService'

@Component({
  components: {
    LoadingComponent,
    AlertBarComponent,
    BreadcrumbsComponent,
    CustomerDialogComponent,
  },
})
export default class MasterCustomerList extends Mixins(GlobalMixin) {
  customersService = CustomersService.instance
  prefecturesService = PrefecturesService.instance

  /** データテーブル ヘッダー設定 */
  headers = [
          { text: "顧客コード", value: "code", width: "140px" },
          { text: "顧客名", value: "customerShortName", width: "240px" },
          { text: "部署名", value: "customerDepartment", width: "200px" },
          { text: "住所", value: "customerAddress" },
          { text: "電話番号", value: "customerTel", width: "120px" },
          { text: "営業拠点", value: "salesOffice", width: "100px" },
          { text: "顧客区分", value: "customerClassification", width: "100px" },
          { text: "報告書添付ルール", value: "billingRule", width: "150px" },
          { text: "締日", value: "deadline", align: "end", width: "80px" },
          { text: "代理店", value: "agencied", align: "center", width: "100px" },
          { text: "納期計算", value: "deliveryCalculation", width: "120px" },
          { text: "操作", value: "actions", sortable: false, width: "120px" },
  ]
  list: CustomerInfo[] = []
  rowItemKey = ""
  rowItemClickTime = 0
  prefecturs: Prefectur[] = []

  dto: Customer =  new Customer()
  customerDialog = false

  /** 検索キーワード */
  keyword = ""

  /**
   * 初期実行
   */
  mounted() {
    /* 都道府県 */
    this.prefecturesService.findAll()
      .then(x => this.prefecturs = x)
    /* 初期検索 */  
    this.search()
  }

  /**
   * 行クリック時の処理
   */
  onClickRow(event: CustomerInfo) {
    const now = (new Date()).getTime()
    if ((now - this.rowItemClickTime) <= 500 && this.rowItemKey === event.customerKey) {
      this.onEdit(event.customerPrefectureCode, event.customerCode, event.customerBranchNumber)
    }
    this.rowItemKey = event.customerKey
    this.rowItemClickTime = now
  }

  /**
   * 都道府県名を取得する
   */
  getPrefectureName(code: string) {
    const prefectur = this.prefecturs.find(x => x.code === code)
    return prefectur === undefined ? "" : prefectur.name
  }

  /**
   * 新規作成
   */
  onNew() {
    this.customersService.createNew()
      .then(x => {
        this.viewMode = VIEW_MODE.NEW
        this.dto = x
        this.dto.pk.branchNumber = "00"
        this.customerDialog = true
      })
  }

  /**
   * 顧客区分の年次更新
   */
  onAnnualUpdate() {
    this.confirm("顧客区分をすべて既存に更新してよろしいですか？").then(res => {
      if (res === true) {
        this.customersService.annualUpdate()
            .then(() => {
              this.alert("顧客区分の年次更新を実施しました", ALERT_TYPE.SUCCESS)
              this.hideLoading()
              this.search()
            })
            .catch((error) => {
              // eslint-disable-next-line
              console.log(error)
              this.alert("顧客区分の年次更新に失敗しました", ALERT_TYPE.ERROR)
              this.hideLoading()
            })
      }
    })
  }

  /**
   * 支店追加
   */
  onBranchNew(prefectureCode: string, code: string, branchNumber: string) {
    const maxBranchNumber = this.list.filter(x => x.customerPrefectureCode === prefectureCode && x.customerCode === code)
                                      .map(x => x.customerBranchNumber)
                                      .reduce((a, b) => a > b ? a : b, "00")
    const newBranchNumber = ("00" + (parseInt(maxBranchNumber) + 1).toString()).slice(-2)
    this.customersService.edit(prefectureCode, code, branchNumber)
      .then(x => {
        this.viewMode = VIEW_MODE.NEW
        this.dto = x
        this.dto.pk.branchNumber = newBranchNumber
        this.customerDialog = true
      })
  }

  /**
   * 編集
   */
  onEdit(prefectureCode: string, code: string, branchNumber: string) {
    this.customersService.edit(prefectureCode, code, branchNumber)
      .then(x => {
        this.viewMode = VIEW_MODE.EDIT
        this.dto = x
        this.customerDialog = true
      })
  }

  /**
   * ダイアログの確定処理
   */
  onCustomerSubmit(dto: Customer) {
    this.showLoading()
    if (this.viewMode === VIEW_MODE.NEW) {
      /* 新規登録 */
      this.customersService.create(dto)
          .then(() => {
            this.alert("保存しました", ALERT_TYPE.SUCCESS)
            this.hideLoading()
            this.search()
          })
          .catch((error) => {
            // eslint-disable-next-line
            console.log(error)
            this.alert("保存に失敗しました", ALERT_TYPE.ERROR)
            this.hideLoading()
          })
    } else {
      /* 更新 */
      this.customersService.update(dto)
          .then(() => {
            this.alert("保存しました", ALERT_TYPE.SUCCESS)
            this.hideLoading()
            this.search()
          })
          .catch((error) => {
            // eslint-disable-next-line
            console.log(error)
            this.alert("保存に失敗しました", ALERT_TYPE.ERROR)
            this.hideLoading()
          })
    }
  }

  /**
   * 検索処理
   */
  search() {
    this.showLoading()
    this.customersService.findAll()
      .then(x => {
        this.list = x
        this.hideLoading()
      })
      .catch(error => {
        // eslint-disable-next-line
        console.log(error)
        this.alert("検索エラー", ALERT_TYPE.ERROR)
        this.hideLoading()
      })
  }
}
